var newsletter = {

    $form: $('#form_newsletter'),
    $input: $('input.email'),

    init: function () {
        this.setListeners();
    },

    setListeners: function () {
        var $this = this;

        this.$form.find('button').on('click', function(e) {
            e.preventDefault();

            if ($this.IsEmail($this.$input.val())) {
                $this.$form.submit();
            }
            else {
                $this.$input.addClass('fielderror');
                $('.bloc-newsletter > div.bloc-information > span').html(__('client_invalid_mail')).addClass('color-red');
            }
        });

        // this.$form.on('submit', function(e) {
        //     e.preventDefault();
        //     if ($this.IsEmail($this.$input.val())) {
        //         window.location.href = this.$input.data('href');
        //     }
        //     else {
        //         alert('Email non valide');
        //     }
        // });
    },

    IsEmail: function (email) {
        var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

        if (!regex.test(email)) {
            $return = false;
        } else {
            $return = true;
        }

        return $return;
    }
};

(function ($) {
    newsletter.init();
})(jQuery);

